import { createMetadata } from "../../lib/seo";
import { siteConfig } from "../../lib/site-config";

export const metadata = createMetadata({
  title: "隐私政策",
  description:
    "增长深度 GrowDeep 隐私政策，说明我们如何收集、使用和保护您在提交增长诊断或项目咨询时提供的企业与联系信息。",
  path: "/privacy",
  keywords: [
    "增长深度隐私政策",
    "GrowDeep隐私政策",
    "咨询信息保护",
    "企业信息隐私",
  ],
});
export default function PrivacyPage() {
  return (
    <article className="legal-page">
      <h1>隐私政策</h1>
      <p>更新日期：2026 年 7 月 30 日</p>
      <h2>我们收集的信息</h2>
      <p>
        当您提交增长诊断申请、订阅内容或与我们沟通项目需求时，我们可能收集企业名称、联系人、联系方式、现有网站、所属行业、目标市场及您主动提供的业务信息。此类信息用于回复咨询、安排沟通和评估服务匹配度。
      </p>
      <h2>信息使用</h2>
      <p>
        相关信息仅用于提供咨询、项目评估、服务沟通和必要的项目协作。未经您的同意，我们不会将您的业务信息用于与上述目的无关的营销活动，也不会向无关第三方出售或出租该等信息。
      </p>
      <h2>信息保护</h2>
      <p>
        我们采用合理的访问控制、权限管理与数据管理措施保护您提交的信息，并仅向履行工作职责所必需的人员开放。您可以通过
        {siteConfig.contact.email} 联系我们查询、更正或删除相关信息。
      </p>
    </article>
  );
}
